.AnimatedValue {
  position: absolute;
  inset: 0;
  pointer-events: none;
  display: flex;
  align-items: center;

  .Value {
    position: absolute;
    left: 0;
    right: 0;

    &.enter {
      &.up {
        animation: slideInUp 0.15s forwards;
      }

      &.down {
        animation: slideInDown 0.15s forwards;
      }
    }

    &.exit {
      &.up {
        animation: slideOutUp 0.15s forwards;
      }

      &.down {
        animation: slideOutDown 0.15s forwards;
      }
    }
  }
}

@keyframes slideInUp {
  from {
    transform: translateY(120%);
    opacity: 0.2;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOutUp {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-120%);
    opacity: 0.2;
  }
}

@keyframes slideInDown {
  from {
    transform: translateY(-120%);
    opacity: 0.2;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOutDown {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(120%);
    opacity: 0.2;
  }
}
